import { render, staticRenderFns } from "@/modules/Task/templates/task-list.html?vue&type=template&id=73244538&scoped=true&"
import script from "@/modules/Task/scripts/task-list.ts?vue&type=script&lang=js&"
export * from "@/modules/Task/scripts/task-list.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Task/styles/task-list.scss?vue&type=style&index=0&id=73244538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73244538",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VTooltip})
